import React, { ReactNode, useEffect, useRef, useState } from "react";
import cx from "classnames";
import { useLocation } from "@reach/router";
import SimpleBar from "simplebar-react";

import Header from "../Header";
import Footer from "../Footer";

import styles from "./index.module.scss";

interface PageLayoutProps {
  children: ReactNode;
  className?: string;
}

const PageLayout: React.FC<PageLayoutProps> = ({ children, className = "" }) => {
  const contentRef = useRef<any>(null);
  const [contentScrolled, setContentScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const node = contentRef.current?.getScrollElement?.();
    if (!node) return;

    const handleScroll = () => {
      setContentScrolled(node.scrollTop > 100);
    };

    node.addEventListener("scroll", handleScroll);
    return () => node.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const node = contentRef.current?.getScrollElement?.();
    if (node) node.scrollTop = 0;
  }, [location.pathname]);

  return (
    <div className={cx(styles.PageLayout, className)}>
      {!location.pathname.startsWith("/scribe-signup") &&
        location.pathname !== "/infoway-scribe-signup/" && <Header isScrolled={contentScrolled} />}
      <SimpleBar className={styles.ScrollArea} ref={contentRef}>
        {children}
        {!location.pathname.startsWith("/scribe-signup") &&
          location.pathname !== "/infoway-scribe-signup/" && <Footer />}
      </SimpleBar>
    </div>
  );
};

export default PageLayout;
